import type { ResultCategory } from './types';

export const normalizeWeights = (weights: Record<ResultCategory, number>) => {
  const total = Object.values(weights).reduce((acc, val) => acc + val, 0);
  return Object.entries(weights).reduce<Record<ResultCategory, number>>(
    (acc, [category, weight]) => ({
      ...acc,
      [category]: weight / total,
    }),
    {} as Record<ResultCategory, number>,
  );
};
